import React from 'react'

const WindowTint = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} d="M51.97 439.81l-.07-221.127S158.378 111.837 175.471 95.112C191.05 79.869 210.182 73 231.403 73h228.931v366.81H51.97z" />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M100.777 223.683s85.557-83.909 98.798-97.15 29.378-17.315 43.797-17.315h179.262v114.466l-321.857-.001h0zM352.52 264.673h66.789M149.913 185.145l32.838 32.839M183.79 151.268l66.622 66.621M219.794 119.516l99.395 99.396M281.871 113.838l104.979 104.98M349.531 113.744l69.242 69.242"
    />
  </svg>
)
export default WindowTint
